import React, { useCallback, useState } from 'react';

const GatekeepingUIContext = React.createContext();

function GatekeepingUIContextProvider({ children }) {
  const [loading, setLoading] = useState([]);

  const addLoading = useCallback((id) => {
    setLoading((loading) => [...loading, id]);
  }, []);

  const removeLoading = useCallback((id) => {
    setLoading((loading) => loading.filter((id_) => id !== id_));
  }, []);

  const isLoading = useCallback((id) => loading.indexOf(id) !== -1, [loading]);

  const value = {
    addLoading,
    removeLoading,
    isLoading,
  };

  return <GatekeepingUIContext.Provider value={value}>{children}</GatekeepingUIContext.Provider>;
}

export default GatekeepingUIContext;
export { GatekeepingUIContextProvider };
